import React from 'react';

export default class Comments extends React.Component {
  constructor() {
    super();

    this.state = {
      isEdit: false,
      isReply: false,
      value: '',
      id: '',
      parentId: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.isReply)
      this.props.onSubmit(this.state.parentId, this.state.value);
    else
      this.props.onUpdateSubmit(this.state.id, this.state.value);
    this.setState({
      isEdit: false,
      isReply: false,
      id: ''
    })
  }

  onEdit = (id) => {
  this.setState({
    isEdit: true,
    isReply: false,
    id: id
  })
  };

  onSave = (id) => {
    this.setState({
      id: id
    })
  };

  onDelete = (id) => {
    //this.setState({
    //  id: id
    //})
    this.props.onDeleteSubmit(id)
  };

  onReply = (id) => {
    this.setState({
      isReply: true,
      isEdit: false,
      id: id,
      parentId: id
    })
  };

  toggleComment = () => {
    this.setState({
      isEdit: false,
      isReply: false,
      id: ''
    })
  };

  render() {
    const { comments, userid, mode } = this.props;
    const inputClass = this.state.isEdit ? '' : 'hide';
    const inputReplyClass = this.state.isReply ? '' : 'hide';

    return (
      <div className="chat-body no-padding profile-message">
        <ul>
          {comments && comments.map((comment, idx) => (
            <div key={idx} data-comment-id={comment.id}>
              {
                comment.parentId == null && (
                  <li key={idx} className="message" >
                    <img src="assets/img/avatars/1.png" alt="" className="online" />
                    <span className="message-text">
                      <a className="username">
                        {comment.username}
                        &nbsp;&nbsp;<span className="badge"> {comment.role}</span>
                      </a>
                      {(comment.comment)}

                      {this.state.id === comment.id && (
                        <form method="post" onSubmit={this.handleSubmit} >
                          <div className={inputClass}>
                            <textarea rows="2" className="form-control" onChange={this.handleChange} defaultValue={comment.comment}></textarea>
                            <button type="button" className="btn btn-default" onClick={this.toggleComment} >
                              Cancel
					                  </button> &nbsp;&nbsp;
                            <button type="submit" className="btn btn-sm btn-primary pull-right" onClick={(e) => this.onSave(comment.id, e)} >
                              Save
					                  </button>
                          </div>
                        </form>
                      )}
                    </span>
                    {userid === comment.createdBy &&
                      (
                        <ul className="list-inline font-xs">
                          <li>
                            <a className="text-primary" onClick={(e) => this.onEdit(comment.id, e)}>Edit</a>
                          </li>
                          <li>
                            <a className="text-danger" onClick={(e) => this.onDelete(comment.id, e)}>Delete</a>
                          </li>
                        </ul>
                      )}
                    {(userid !== comment.createdBy) && !mode &&
                      (
                        <ul className="list-inline font-xs">
                          <li>
                            <a disabled={this.props.isExecutive} className="text-info" onClick={(e) => this.onReply(comment.id, e)}><i className="fa fa-reply"></i> Reply</a>
                          </li>
                        </ul>
                      )}
                    <ul className="list-inline font-xs">
                      <li>

                      </li>
                      <li className="pull-right">
                        <small className="text-muted pull-right ultra-light">Created At: {comment.createdAt}</small>
                      </li>
                    </ul>

                    {this.state.id === comment.id && (
                      <form method="post" onSubmit={this.handleSubmit} >
                        <div className={inputReplyClass}>
                          <span className="message-text">
                          <textarea rows="2" className="form-control" onChange={this.handleChange} ></textarea>
                          <button type="button" className="btn btn-default" onClick={this.toggleComment} >
                            Cancel
					                  </button> &nbsp;&nbsp;
                            <button type="submit" className="btn btn-sm btn-primary pull-right"  >
                            Save
					                  </button>
                          </span>
                        </div>
                      </form>
                    )}

                  </li>
                )

              }
              {
                comment.parentId != null && (
                  <li key={idx} className="message message-reply">
                    <img src="assets/img/avatars/3.png" className="online" alt="user" />
                    <span className="message-text">
                      <a className="username">
                        {comment.username}
                        &nbsp;&nbsp;<span className="badge"> {comment.role}</span>
                      </a>
                      {comment.comment}
                    </span>
                    <ul className="list-inline font-xs">
                      <li>
                        <a className="text-muted">Created At: {comment.createdAt}</a>
                        </li>

										  </ul>

									</li>
              )}

            </div>
        ))}
        </ul>

      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/routes/administration/components/Comments.js